import React, { useEffect, useRef } from 'react'
import { useKeyPress, useClickAway } from 'react-use'
import styled from 'styled-components'
import { colors, Button } from '@giphy/react-giphy-brand'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import { Modal } from '../modal'

const Container = styled.div`
    position: absolute;
    top: 170px;
    left: 50%;
    width: 620px;
    height: auto;
    padding: 55px;
    transform: translateX(-50%);
    background-color: ${colors.giphyDarkestGrey};
    & p {
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        margin: 0;
        line-height: 25px;
    }

`

const Links = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 35px;
`

const DownloadButton = styled(Button)`
    height: 44px;
    width: 248px;
    color: ${colors.giphyWhite};
    background-color: ${colors.giphyDarkGrey};
    &:hover {
        color: ${colors.giphyBlue};
    }
    i {
        margin-right: 5px;
        top: 3px;
        position: relative;
    }
`

type Props = {
    csv: string
    csvCtr: string
    onClose: () => void
}

const CsvModal = ({ csv, csvCtr, onClose } : Props) => {
    const [isEscPressed] = useKeyPress((event: KeyboardEvent) => event.keyCode === 27)
    useEffect(() => {
        if (isEscPressed) {
            onClose()
        }
    }, [isEscPressed])
    const ref = useRef(null)
    useClickAway(ref, () => {
        onClose()
    })
    return (
        <Modal>
            <Container ref={ref}>
                <p>{`Select the data you'd like to download for your GIFs. Engagement Rate on GIPHY shows the percentage of times a user engages with your GIFs in search!`}</p>
                <Links>
                    <a href={csv}>
                        <DownloadButton onClick={() => 
                            googleAnalyticsEvent({ 
                                category: 'Dashboard', 
                                action: 'CSV Download', 
                                label: 'Views',
                        })}>
                            <i className={'ss-download'} />
                            <span>View Count CSV</span>
                        </DownloadButton>
                    </a>
                    <a href={csvCtr}>
                        <DownloadButton onClick={() => 
                            googleAnalyticsEvent({ 
                                category: 'Dashboard', 
                                action: 'CSV Download', 
                                label: 'Engagement Rate',
                        })}>
                            <i className={'ss-download'} />
                            <span>Engagement Rate CSV</span>
                        </DownloadButton>
                    </a>
                </Links>
            </Container>
        </Modal>           
)
}

export default CsvModal
